import { action, flow, makeObservable, observable } from 'mobx';
import { ApiServices, ApiServiceTypes } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { convertObjectToArray } from '../helpers/convertObjectToArray';

class StatisticsStore {
  statisticsData = {};

  constructor() {
    makeObservable(this, {
      statisticsData: observable.deep,
      setStatisticsData: action.bound,
      getStatisticsData: flow.bound,
    });
  }

  setStatisticsData(statisticsData) {
    this.statisticsData = statisticsData;
  }

  *getStatisticsData() {
    const { gameTypeId } = gameConfigStore;
    const {
      data: { result },
    } = yield ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({ gameTypeId });
    this.setStatisticsData(convertObjectToArray(result));
  }
}

export const statisticsDataStore = new StatisticsStore();
